import React from 'react';
import { Form } from '@sharingapples/form';
import { WhitePanelLayout, TextInput, MultilineTextInput, FormSubmitButton } from '@dom/components';

import updateGuideData from '../../api/updateGuideData';

import { useSelector } from '../../redux';
import { getGuideDataById } from '../../redux/selectors';

import { getEditedKeysOnly } from '../../utils';

export default function GuideBasicInformationForm({ userId }) {

  const { 
    baseCity,
    fullname,
    about,
    expertiseRegions,
   } = useSelector(getGuideDataById(userId)) || {};

   const intialValues = {
     fullname,
     baseCity,
     about,
     expertiseRegions: expertiseRegions && expertiseRegions.join(', '),
   };

   console.log(userId, intialValues);

  const patchData = (state) => {
    const editedState = getEditedKeysOnly(state);
    if(editedState.expertiseRegions) {
      const { expertiseRegions } = editedState;
      editedState.expertiseRegions = expertiseRegions.split(',');
    };

    updateGuideData(userId, editedState);
  };

  return (
    <WhitePanelLayout>
      <Form onSubmit={patchData} defaultValue={intialValues}>
        <TextInput name="fullname" label="Name" className="inline-input" autoFocus />
        <MultilineTextInput
          name="about"
          label="Introduction"
          className="inline-input"
        />
        <TextInput name="baseCity" label="Based In" className="inline-input" />
        <TextInput
          name="expertiseRegions"
          label="Preferred Trekking Regions"
          className="inline-input"
        />
        <div></div>
        <FormSubmitButton buttonText="Save" className="btn-sm"/>
      </Form>
    </WhitePanelLayout>
  );
}
